import * as React from 'react';
import { applyQueryString, api } from 'services';
import { useAuth } from 'hooks/auth';
import type { Filters } from 'hooks/store/loading-orders';

type OrderType = '1' | '2';

type FetchOrdersParams = {
  filters?: Filters;
  orderType: OrderType;
};

export const useFetchOrders = () => {
  const { token } = useAuth();

  const fetchOrders = React.useCallback(async (payload: FetchOrdersParams) => {
    const { statuses, ...rest } = payload?.filters || {};

    const filters =  {
      ...rest,
      status: statuses,
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (!value || (Array.isArray(value) && !value?.length)) {
        delete (filters as Record<string, unknown>)[key];
      }
    });

    const url = applyQueryString('/orders', {
      ...filters,
      orderTypeId: payload.orderType,
    })

    const { data } = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  }, [token]);

  return {
    fetchOrders,
  }
};
